export default __webpack_public_path__ + "static/media/MountainSlopes.4cc63114.jpg";